module.exports = __webpack_public_path__ + "static/media/radioactive-materials-waste-manage.2d973d71.svg";